<template>
  <ModalContainer :showModal="showModal" :title="isEdit ? 'Edit Category' : 'Create Category'" @closeModal="closeModal">
    <div id="modal-body" class="p-6">
      <AlertDanger v-if="alert_danger" :text="alert_text" @closeAlertDanger="hideAlertDanger()" />
      <InputForm
        id="category-name"
        v-model="category.name"
        input_class="w-full mb-5"
        label="Category Name"
        label_class="mb-1 block text-start"
        type="text"
        placeholder="e.g. Sulam"
        :is_required="true"
      />
    </div>
    <div class="modal-footer pb-6">
      <div class="flex justify-center gap-2">
        <Button @click="closeModal" id="close-modal" button_text="Close" />
        <Button @click="submit()" id="submit" button_text="Submit" />
      </div>
    </div>
  </ModalContainer>
</template>

<script>
import ModalContainer from "@/components/modals/ModalContainer.vue";
import Button from "@/components/buttons/Button.vue";
import InputForm from "@/components/form/InputForm.vue";
import AlertDanger from "@/components/alerts/AlertDanger.vue";
import { mapActions, mapGetters } from "vuex";
import { validationPhoneNumber, validationEmail } from "@/helpers/validation";
import Select from '@/components/form/Select.vue';

export default {
  name: "ModalAddCategory",
  props: {
    categoryData: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: Number,
      default: null,
    },
  },
  emits: ["openAlertSuccess_CategoryCreated", "openAlertSuccess_CategoryUpdated", "closeModal"],
  components: {
    InputForm,
    Button,
    AlertDanger,
    ModalContainer,
    Select,
  },
  data() {
    return {
      showModal: true,
      alert_danger: false,
      alert_text: "",
      isEdit: false,
      category: {
        id: null,
        name: '',
      },
    };
  },
  async created() {
    if (this.categoryData) {
      this.isEdit = true;
      this.category.id = this.categoryData.id;
      this.category.name = this.categoryData.name;
    }
  },
  methods: {
    ...mapActions("categories", ["createCategory", "updateCategory"]),
    validationPhoneNumber, validationEmail,

    async fetchCategories(id) {
      const params = {
        id: id
      };
      const response = await this.$store.dispatch('categories/fetchCategories', params);
      console.log('categoryData: ', response);
    },

    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },

    capitalizeName(name) {
      return name
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },

    async submit() {
      if (!this.category.name) {
        this.alert_danger = true;
        this.alert_text = "Category Name cannot be empty!";
        return;
      }
      
      this.category.name = this.capitalizeName(this.category.name);
      try {
        if (this.isEdit) {
          await this.updateCategory(this.category);
          this.$emit('openAlertSuccess_categoryUpdated');
        }
        else {
          await this.createCategory(this.category);
          this.$emit('openAlertSuccess_CategoryCreated');
        }
        this.closeModal();
      }
      catch (error) {
        console.error(error);
        this.alert_danger = true;
        this.alert_text = "Error: " + error.message;
      }
    },

    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = "";
    },
  },
};
</script>